import React, { useEffect, useState, Fragment } from 'react';
import { isEmpty } from "lodash"

import Spin from '../../../commonModules/interface/Spin';
import { BreadCrumb } from './containers/Layout';
import SinglePurchase from './transfers/purchases/SingleTransferPurchase.jsx';
import ListPurchase from './transfers/purchases/ListTransferPurchase.jsx';
// import ListPurchase from './purchases/ListPurchase.jsx';
import Form from './purchases/Form.jsx';
import ListPurchaseItem from './purchases/ListPurchaseItem.jsx';
import SingleShop from './shops/SingleShop';
import { Button, Box, IconButton, Grid } from '@material-ui/core';
import { ListAltRounded, ListRounded } from '@material-ui/icons';
import CardPage from '../../../commonModules/layouts/CardPage';
import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import DateFilter, { filterDate } from './Filter/DateFilter';
import ShopFilter, { filterShop } from './Filter/ShopFilter';
import { firstDayOfYear } from '../../../commonModules/utils/statsFunctions';
import AccordionFilter from './Filter/AccordionFilter';

const Purchases = (props) => {

    
    const [state, setState] = useState({       
        view: props.new ? "new" : "list",
        listview: "purchase",

        singleShop:{},
        updatePurchase:{},
        singlePurchase:{
            purchase:{},
            shop:{},
        },

        breadcrumb: "",
        mdpAdmin:'',

        currentPage: 0,
        currentPageProd: 0,
        rowsPerPage: 20,

        search:"",
        received: "",
        searchType: "",
        searchClient: "",
        searchFacture: "",
        searchPointing5000: "",
        selectShop: {label:"", value:""},
        searchProduct: "",
        start_date: firstDayOfYear,
        end_date: (() => {
            const endDate = new Date();
            endDate.setHours(23, 59, 59, 0);
            return endDate;
          })(),
        
    })    
        
    // CLEAR & DISPLAY
        const handleClose = () => {// close all dialog and singles
            setState(prevState => ({...prevState,
                view: "list",
                breadcrumb: ""
            }));
        }
        const handleSinglePurchase = (purchase, shop) => {// open single shop page
            setState(prevState => ({...prevState,
                breadcrumb: `${purchase.nature} n°${purchase.id}`,
                singlePurchase:{
                    shop,
                    purchase
                },
                view: "purchase"
            }))
        }
        const handleUpdatePurchase = (purchase) => {
            setState(prevState => ({...prevState,
                breadcrumb: `Modifier l'achat n°${purchase.id}`,
                updatePurchase: purchase,
                view: "update"
            }))
        }
        const handleSingleShop = (shop) => {// open single shop page
            setState(prevState => ({...prevState,
                breadcrumb: shop.name,
                singleShop:shop,
                view: "shop"
            }))
        }
        
        const onChangePage = (pageOfItems, page, rowsPerPage) => {
            setState(prevState => ({...prevState,
                currentPage:page, rowsPerPage }));
        }
        const onChangePageProd = (pageOfItemsProd, page, rowsPerPage) => {
            setState(prevState => ({...prevState,
                currentPageProd: page, rowsPerPage }));
        }
    
        const normalizeStr = (str) => {// remove accent and lower case str
            if (str){
                console.log("str exist", {str}, isEmpty(str));
                str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
            }
            return str
        }
        const prodFilter = (prodID) => {
            const { PRODUCTS } = props;
            const { searchProduct } = state
    
            let product = PRODUCTS[prodID]
            let searching = searchProduct ? normalizeStr(searchProduct) : ""
    
            const productName = product ? normalizeStr(product.name) : ""
            const productRef = product ? normalizeStr(product.ref) : ""
            const productType = product ? normalizeStr(product.type) : ""
            const productBrand = product ? normalizeStr(product.marque) : ""
    
            return ( 
                productName.indexOf(searching) !== -1 ||
                productRef.indexOf(searching) !== -1 ||
                productType.indexOf(searching) !== -1 ||
                productBrand.indexOf(searching) !== -1
            )  
        }

        const handleChange = (e) => {
            const { name, value } = e.target;
            setState(prevState => ({...prevState,
                [name]: value,
                currentPage: 0,
                currentPageProd: 0,
            }))
        }
        const handleSelect = (option, name) => {
            setState(prevState => ({...prevState,
                [name]: option.value, 
                currentPage: 0,
                currentPageProd: 0,
            }))
        } 

        const handleSelectMulti = (option, name) => {
            if(option){
                setState(prevState => ({...prevState,              
                    [name]: option,
                    currentPage: 0,
                    currentPageProd: 0,
                }))
            } else {
                setState(prevState => ({...prevState,
                    [name]: {label: "", value: ""},
                    currentPage: 0,
                    currentPageProd: 0,
                }))
    
            }
        }
        const getFilteredList = (purchaseList) => {
            //const { PURCHASES } = props
            const {selectShop, received, searchFacture, searchType, searchPointing5000 } = state;
            
            // let list = Object.values(PURCHASES)
            let list = filterDate(purchaseList, state.start_date, state.end_date, "creation_date")
            // status
            if (typeof received == "boolean"){
                list = list.filter(item => item.received == received)
            }
            // type
            if (typeof searchType == "boolean"){
                list = list.filter(item => item.is_imported == searchType)
                // if (searchType) {
                // } else {
                //     list = list.filter(item => item.nature !== "reapprovisionnement_ext")
                // }
            }

            list = filterShop(list, selectShop)

            if(!isEmpty(searchFacture)){
                list = list.filter(purchase => purchase.id && purchase.id.indexOf(searchFacture.toLocaleLowerCase()) > -1)
            }
            if(!isEmpty(searchPointing5000)){
                list = list.filter((item) => {
                    const isPointed5000 = Boolean(item.fact_id_5000) || Boolean(item.matched);
                    if (searchPointing5000 === "pointed") return isPointed5000;
                    if (searchPointing5000 === "unpointed") return !isPointed5000;
                    return true;
                });
            }
          
            return list
        }


        return(
            <CardPage title="Achats" storehouse action={
                <Box>
                    {state.view === "list" && 
                        <Fragment>
                            <Button color="primary" variant="contained"
                                onClick={ () =>
                                    setState(prevState => ({...prevState,
                                        view: "new", breadcrumb:"Nouveau" }))
                                }> Nouvel Achat 
                            </Button>
                            {state.listview === "purchase" &&
                                <IconButton 
                                    color="secondary"
                                    title="Vue Produits"
                                    onClick={()=>
                                        setState(prevState => ({...prevState,
                                            view: "list", listview: "prodList" }))
                                    }>
                                    <ListRounded />
                                </IconButton> 
                            } 
                            {state.listview === "prodList" &&
                            <IconButton 
                                color="secondary" 
                                title="Vue Achats"
                                onClick={()=>
                                    setState(prevState => ({...prevState,
                                        view: "list", listview: "purchase" }))
                                }>
                                <ListAltRounded />
                            </IconButton> 
                            } 
                        </Fragment>
                    }
                </Box>
                }
            >
                <BreadCrumb 
                    breadcrumb={ state.breadcrumb } 
                    title="Achats" 
                    back={handleClose} 
                />

                {state.view === "shop" &&
                    <SingleShop shop={state.singleShop} {...props} />
                }       
                {state.view === "new" &&
                    <Form 
                        {...props}
                        handleClose={handleClose}
                    />
                }
                {state.view === "update" &&
                    <Form 
                        {...props}
                        update
                        oldPurchase={state.updatePurchase}
                        handleClose={handleClose}
                    />
                }
                {state.view === "purchase" &&
                    <SinglePurchase 
                        {...props}
                        purchase={state.singlePurchase.purchase} 
                        shop={state.singlePurchase.shop} 
                        handleUpdatePurchase={handleUpdatePurchase} 
                    />
                }

                {state.view === "list" && 
                    <AccordionFilter>
                        <Grid container>
                            <DateFilter
                                handleChangeDate={(date, name) => setState(prevState => ({...prevState,
                                    [name]: date }))}
                                {...state}
                            />
                            <Grid item xs={12} md={6}>
                                {/* <InputSelect
                                    options={shops}
                                    value={state.selectShop}
                                    label="Sélectionner un Magasin"
                                    name="selectShop"
                                    onChange={(option) => handleSelect(option, "selectShop")}
                                />  */}
                                <ShopFilter
                                    fieldName="selectShop"
                                    value={state.selectShop}
                                    handleSelect={handleSelectMulti}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputSelect
                                    options={[
                                        {value: "", label: "Tous"},
                                        {value: true, label: "Reçu"},
                                        {value: false, label: "En attente"},
                                    ]}
                                    value={state.received}
                                    label="Statut"
                                    name="received"
                                    onChange={(option) => handleSelect(option, "received")}
                                /> 
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputSelect
                                    options={[
                                        {value: "", label: "Tous"},
                                        {value: false, label: "Interne"},
                                        {value: true, label: "Externe"},
                                    ]}
                                    value={state.searchType}
                                    label="Type"
                                    name="searchType"
                                    onChange={(option) => handleSelect(option, "searchType")}
                                /> 
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputText
                                    label="Facture"
                                    value={state.searchFacture}
                                    name="searchFacture"
                                    onChange={handleChange}
                                /> 
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <InputSelect
                                    options={[
                                        {value: "", label: "Tous"},
                                        {value: "pointed", label: "Pointés"},
                                        {value: "unpointed", label: "Non pointés"},
                                    ]}
                                    value={state.searchPointing5000}
                                    label="Pointage 5000"
                                    name="searchPointing5000"
                                    onChange={(option) => handleSelect(option, "searchPointing5000")}
                                />
                            </Grid>
                            {state.listview === "prodList" &&
                            <Grid item xs={12} md={6}>
                                <InputText 
                                    name="searchProduct" 
                                    value={state.searchProduct} 
                                    placeholder="Rechercher par produit " 
                                    label="Rechercher"
                                    onChange={ handleChange} 
                                />
                            </Grid>
                            }
                        </Grid>
                    </AccordionFilter>
                }
                {props.STATE.purchases.fetching && <Spin noOverlay/>}
                
                {state.view === "list" && state.listview === "purchase" &&
                    <Box>
                        {/* {!isEmpty(props.PURCHASES) &&
                            
                            } */}
                        <ListPurchase 
                            {...props}
                            {...state}
                            onChangePage={onChangePage}
                            handleSingleShop={handleSingleShop}  
                            // handleUpdatePurchase={handleUpdatePurchase} 
                            handleSinglePurchase={handleSinglePurchase} 
                            getFilteredList={getFilteredList} 
                            prodFilter={prodFilter}  
                        />
                    </Box>
                }
                {state.view === "list" && state.listview === "prodList" &&
                    <Box>
                        {!isEmpty(props.PURCHASES) &&
                            <ListPurchaseItem
                                {...props}
                                {...state}
                                dataview="achat"
                                onChangePage={onChangePageProd}
                                handleSingleShop={handleSingleShop}  
                                handleSinglePurchase={handleSinglePurchase} 
                                getFilteredList={getFilteredList} 
                                prodFilter={prodFilter}   
                                // notif={notif}  
                            />
                        }
                    </Box>
                }
            </CardPage>
        )
}

export default Purchases